<template>
  <div>
    <div class="row">
      <b-form-group class="col-12 col-sm-6 col-md-4"
        label="Titulo"
        label-for="title">

        <b-form-input id="name"
          type="text"
          :value="seo.title"
          @input="updateSeo('title', arguments[0])"
          placeholder="Título"
          :class="{
            'is-invalid': form.errors.has('seo.title'),
            'is-valid': !form.errors.has('seo.title')
        }"></b-form-input>
      </b-form-group>

      <b-form-group class="col-12 col-sm-6 col-md-8"
        label="Descrição"
        label-for="description"
        description="Utilize no máximo 80 caracteres">

        <b-form-input id="name"
          type="text"
          :value="seo.description"
          @input="updateSeo('description', arguments[0])"
          placeholder="Descrição"
          :class="{
            'is-invalid': form.errors.has('seo.description'),
            'is-valid': !form.errors.has('seo.description')
        }"></b-form-input>
      </b-form-group>
    </div>

    <div class="row">
      <div class="col-12">
        <b-alert show>
          A URL amigavel deve facilitar o acesso ao conteúdo. Ela deve ser única para cada tipo de conteúdo.
          <br>
          Desta forma, para criar uma nova URL utilize o mecanismo para verificar a existência.
        </b-alert>
      </div>

      <b-form-group class="col-12"
        label="Nova URL"
        label-for="url"
        description="Não utilize caracteres especiais">

        <b-input-group>
          <b-form-input id="url"
            type="text"
            :value="friendlyUrl"
            @input="updateUrl(arguments[0])"
            :formatter="slugify"
            lazy-formatter
            placeholder=""
            :class="{
              'is-invalid': form.errors.has('friendlyUrl.0.url'),
              'is-valid': !form.errors.has('friendlyUrl.0.url')
          }"></b-form-input>

          <b-input-group-append>
            <b-btn variant="outline-success" @click.stop.provent="checkUrl">Checar</b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <div class="col-12" v-show="showUrls">
        <h4>
          URLs cadastradas
        </h4>

        <b-list-group class="mb-1">
          <b-list-group-item
            :key="`url.url-${index}`"
            v-for="(url, index) in urls"
            class="d-flex justify-content-between align-items-center">

            {{ url.url }}

            <b-badge v-if="index === 0" variant="primary" pill>
              PRINCIPAL
            </b-badge>
          </b-list-group-item>
        </b-list-group>
      </div>

    </div>
  </div>
</template>

<script>
  import { get, set, clone } from 'lodash'
  import slugify from 'slugify'
  import Form from '@/services/form'
  import http from '@/services/api/seo-friendly-urls'

  export default {
    props: {
      slugable: {
        type: String,
        default: ''
      },

      showUrls: {
        type: Boolean,
        default: false
      },

      form: {
        type: [Object],
        required: true
      },

      urls: {
        type: Array,
        default () { return [] }
      }
    },

    data () {
      return {
        empty: {
          title: '',
          description: ''
        },

        newUrl: '',

        urlForm: new Form({
          url: ''
        })
      }
    },

    watch: {
      slugable (newSlugable) {
        if (!this.form.frindly_url) {
          this.newUrl = this.slugify(newSlugable)
        }
      }
    },

    computed: {
      seo () {
        return get(this.form, 'seo', null) || this.empty
      },

      friendlyUrl () {
        return this.newUrl || get(this.form, 'friendly_url', '')
      }
    },

    methods: {
      slugify,

      updateSeo (field, value) {
        let seo = clone(this.seo)

        set(seo, field, value)

        this.form.seo = seo
      },

      updateUrl (value) {
        this.newUrl = value.toLowerCase()

        if (!this.form.friendlyUrls) {
          this.form.initial.friendlyUrls = []
          this.form.friendlyUrls = []
        }

        this.form.friendlyUrls[0] = { url: value.toLowerCase() }
      },

      checkUrl () {
        const self = this

        http.check(self.form.id || null, self.friendlyUrl).then(function (res) {
          self.$toasted.success('Url checada. Não esqueça de salvar!')
          self.newUrl = res.data.url || self.friendlyUrl
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/forms/System/SeoFields.vue